import type { RequiredOnly } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import { cn } from '@/lib/cn';

import type { HelperOptions } from '../types';

type NestedKeys<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? `${K}` | `${K}.${NestedKeys<T[K]>}`
        : never;
    }[keyof T]
  : never;

/** テキストを表示するカラム */
export function simpleTextColumn<TData>(
  id: NestedKeys<TData> & string,
  options: RequiredOnly<HelperOptions, 'i18nKey'>,
): ColumnDef<TData> {
  const {
    i18nKey,
    minWidth = '160px',
    maxWidth,
    sortable = false,
    wrapHeader,
  } = options;
  return {
    accessorKey: id,
    meta: {
      i18nKey,
      wrapHeader,
      thStyle: { minWidth, maxWidth },
      tdStyle: { maxWidth: maxWidth ?? '300px' }, // 文字数が多すぎると表示崩れが起きるので、最大幅を設定
    },
    enableSorting: sortable,
    header: DataTableColumnHeader,
    cell: ({ row, getValue }) => {
      const value = getValue();
      const isSubRow = row.depth > 0;
      return (
        <div
          className={cn(
            isSubRow
              ? 'text-xs text-neutral-muted-on-fill'
              : 'text-sm text-neutral-on-fill',
            'break-all',
          )}
        >
          {value ?? '-'}
        </div>
      );
    },
  } satisfies ColumnDef<TData, string> as ColumnDef<TData>;
}
